import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import {
	ActionTypes,
	changeUserLicenseModel,
	ChangeUserLicenseModelAction
} from 'store/account/subscription';
import { ActionPayload } from 'store/types';

export function useChangeUserLicenseModel(): Operation<
	(payload: ActionPayload<ChangeUserLicenseModelAction>) => void
> {
	const dispatch = useDispatch();

	const [{ loading, error }] = useActivity(ActionTypes.CHANGE_USER_LICENSE_MODEL);

	function handler(payload: ActionPayload<ChangeUserLicenseModelAction>) {
		dispatch(changeUserLicenseModel(payload));
	}

	return [{ loading, error }, handler];
}
